import { Post, mapGet } from '../fetch';

/**
 * @description 项目基础功能接口，接口方法请以fetch开头
 */
export default {
  // 登录
  fetchLogin (params) {
    return Post('/auth/townLogin/login/managerLogin', params);
  },
  // 获取tokeninfo
  fetchMenuAndTokenInfo (params) {
    return Post('/api/manager/managerInfo/tokenRole', params);
  },
  // 获取图表模块数据
  fetchModuleChartData (params) {
    return Post('/basis/datavData/getDataV', params);
  },
  // 获取所有站点
  fetchAllStations (params) {
    return Post('/transport/expressStation/allStation', params);
  },
  // 获取任务详情
  fetchTaskDetail (params) {
    return Post('/transport/courierTask/getCourierTaskInfo', params);
  },
  // 获取站点详情
  fetchStationData (params) {
    return Post('/transport/expressStation/getStationDetailInfo', params);
  },
  // 获取高德任务轨迹点
  fetchTaskPoints (params) {
    return mapGet('/track/terminal/trsearch', params);
  },
  // 获取高德轨迹最新任务点
  fetchLastPoint (params) {
    return mapGet('/track/terminal/lastpoint', params);
  },
  // 金途API参数
  fetchApiParamsOfJT (params) {
    return Post('/transport/courierTask/getTaskHisTraceParam', params);
  }
};
